enum LogisticsListKeys {
  LOGISTIC_LIST_ITEM = 'logistic-list-item',
}

export default LogisticsListKeys
